<lib-multi-select
	[label]="'Services'"
	[multiSelectItems]="multiSelectOptions()"
	[inputPlaceholder]="'Select Services'"
	(selectionEmitter)="onSelectionEmitterEvent($event)"
></lib-multi-select>
